import { render, staticRenderFns } from "./prescriptionSupervisionDetail.vue?vue&type=template&id=5482cc9c&scoped=true"
import script from "./prescriptionSupervisionDetail.vue?vue&type=script&lang=js"
export * from "./prescriptionSupervisionDetail.vue?vue&type=script&lang=js"
import style0 from "./prescriptionSupervisionDetail.vue?vue&type=style&index=0&id=5482cc9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5482cc9c",
  null
  
)

export default component.exports